module.exports = __webpack_public_path__ + "static/media/check-v2.5c876863.svg";